import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type CreateData} from './api';

const domain = 'MODALS/VACATION_PLAN';

export const {action: show} = createAction(
    `${domain}/SHOW_NEW`,
    (institutionSetId: string, showAskForDetailedAttendance?: boolean) => ({
        institutionSetId,
        showAskForDetailedAttendance,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: close, aborted: closeAborted} = createAction(`${domain}/CLOSE`, () => ({}));

export const {
    action: fetchRecipients,
    success: fetchRecipientsSuccess,
    failed: fetchRecipientsFailed,
} = createAction(
    `${domain}/FETCH_RECIPIENTS`,
    (institutionSetId: string) => ({institutionSetId}),
    (response: any) => ({response}),
);

export const {
    action: periodUpdated,
    success: periodUpdatedSuccess,
    failed: periodUpdatedFailed,
    aborted: periodUpdatedAborted,
} = createAction(
    `${domain}/PERIOD_UPDATED`,
    (institutionSetId: string, fieldName: 'from' | 'to') => ({institutionSetId, fieldName}),
    (response: any) => ({response}),
);

export const {action: toggleExcluded} = createAction(`${domain}/TOGGLE_EXCLUDED`, (date: string) => ({date}));

export const {action: updateComment} = createAction(
    `${domain}/UPDATE_COMMENT`,
    (date: string, comment: string | undefined) => ({date, comment}),
);

export const {
    action: submit,
    success: submitSuccess,
    failed: submitFailed,
    aborted: submitAborted,
} = createAction(
    `${domain}/SUBMIT`,
    (data: CreateData) => ({data}),
    () => ({}),
);
